import { render } from "./errorUserLoad.vue?vue&type=template&id=edd9d36a"
import script from "./errorUserLoad.vue?vue&type=script&lang=js"
export * from "./errorUserLoad.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__